module.exports = __webpack_public_path__ + "img/entia-pattern-footer.c23dd17e.svg";